import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control} from 'react-redux-form';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

const reactSelect = (props) => <ReactSelect {...props}/>;

class CustomSelect extends Component {
	render() {
		const {list, model, disabled, matchProp, clearable, searchable, simpleValue, multi, ...rest} = this.props;
		return (
			<Control model={`.${model}`} component={reactSelect} mapProps={{
				name: model,
				options: list,
				value: (props) => { return props.modelValue },
				disabled: disabled,
				matchProp: matchProp,
				clearable: clearable,
				searchable: searchable,
				simpleValue: simpleValue,
				multi: multi
			}} {...rest}/>
		)
	}
}

CustomSelect.defaultProps = {
	disabled: false,
	matchProp: 'label',
	clearable: false,
	searchable: true,
	simpleValue: true,
	multi: false
};

CustomSelect.propTypes = {
	list: PropTypes.array.isRequired,
	model: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	matchProp: PropTypes.string,
	clearable: PropTypes.bool,
	searchable: PropTypes.bool,
	simpleValue: PropTypes.bool,
	multi: PropTypes.bool
};

export default CustomSelect;